import axios from 'axios'
//import qs from 'qs'
import store from '@/store/store'

const idr_api = process.env.VUE_APP_IDR_API

// interceptor on request
axios.interceptors.request.use(function (request) {

  if (request.url.startsWith('http://geoserverhml.eparana.parana') ||
    request.url.startsWith('http://geoserverdes.eparana.parana') ||
    request.url.startsWith('http://geoserver.pr.gov.br')) { // FIXME
    return request
  }

  if (store.getters.getUser && JSON.parse(store.getters.getUser).token.access_token) {
    request.headers.Authorization = `Bearer ${JSON.parse(store.getters.getUser).token.access_token}`
  }
  
  return request
},
function (error) {
  return Promise.reject(error)
})

// interceptor on response
axios.interceptors.response.use(function (response) {
  return response
},
function (error) {
  if (error == 'Error: Network Error') {
    if (error.response == undefined) {
      var networkError = { response: { data: { message: 'Algum recurso necessário para execução desta funcionalidade encontra-se indisponível.' } } }
      error = networkError
    }
  }

  if (error.response != undefined && error.response.status === 403) {
    var permissionError = { response: { data: { message: '403 - Sem acesso a alguns recursos desta funcionalidade.' } } }
    error = permissionError
  }

  return Promise.reject(error)
})

export default {
  // Atividades
/*  setMonitoramentoFerrugem2 (params) {
    return axios.get(`${idr_api}/atividades`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  },

  setMonitoramentoFerrugem3 (arq) {
    return axios.get(`${idr_api}/v1/salvar?data=${arq}`)
  },
  */

  setMonitoramentoFerrugem (arq) {
    return axios.post(`${idr_api}/v1/salvar`, JSON.stringify(arq), {
      headers: {          
        'Content-Type': 'application/json'
      }
    })
  },
  getTotalFontes () {
    return axios.get(`${idr_api}/fontes/total`)
  },
  apagaRegistrosFerrugem () {
    return axios.delete(`${idr_api}/v1/apagar-registros-ferrugem`)
  }
}
